import { CampaignId } from '@shared/types/campaign.ts';

export const apiRoutes = {
  createThematicPackageCampaign: (campaignId: CampaignId) => `/campaigns/${campaignId}/upsell-thematic-campaign`,
};
